<div class="container">
  <div class="icon">
    <span class="material-icons">
      done
    </span>
  </div>
  <div class="message">
  </div>
</div>